import { combineReducers } from 'redux';
import { WidgetType } from 'widgets/WidgetType';
import { createWidgetsReducer } from 'widgets/store/widgetsReducerFactory';
import { buildPlCapsuleConfigSlice } from './config/configslice';
import { PlCapsuleState } from './PlCapsuleState';
import { PlCapsuleActionPayload } from './actions';
import { fillsGraphDataReducer } from 'widgets/fillsGraph/store/data/reducer';

const { reducer: configReducer } = buildPlCapsuleConfigSlice();

const plCapsuleWidgetReducer = combineReducers<PlCapsuleState>({
    config: configReducer,
    stream: fillsGraphDataReducer,
});

export const plCapsuleWidgetsReducer = createWidgetsReducer<
    PlCapsuleState,
    PlCapsuleActionPayload
>(WidgetType.PL_CAPSULE, plCapsuleWidgetReducer);
